import React, { useCallback, useState } from 'react';
import { SupervisorPinModal } from '../../shared/modals/SupervisorPinModal';

type Pending = {
  title?: string;
  message?: string;
  resolve: (pin: string | null) => void;
};

/** Promise-based supervisor PIN prompt. Mount `PinModal` next to the screen. */
export function useSupervisorPinPrompt() {
  const [pending, setPending] = useState<Pending | null>(null);
  const [loading, setLoading] = useState(false);

  const promptPin = useCallback((opts?: { title?: string; message?: string }) => {
    return new Promise<string | null>((resolve) => {
      setPending({
        title: opts?.title,
        message: opts?.message,
        resolve,
      });
    });
  }, []);

  const PinModal = pending ? (
    <SupervisorPinModal
      visible
      title={pending.title}
      message={pending.message}
      loading={loading}
      onClose={() => {
        if (loading) return;
        pending.resolve(null);
        setPending(null);
      }}
      onConfirm={async (pin) => {
        setLoading(true);
        try {
          pending.resolve(pin);
          setPending(null);
        } finally {
          setLoading(false);
        }
      }}
    />
  ) : null;

  return { promptPin, PinModal };
}
